import { fromJS, Record, Set } from '@gonfalon/immutable-shim/immutableShim';
import type { ValidationResults } from '@gonfalon/legacy-form-validation/validationUtils';
import {
  isLength,
  isNotEmpty,
  isReservedKey,
  isValidEach,
  validateRecord,
} from '@gonfalon/legacy-form-validation/validationUtils';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';
import { isValidKey } from '@gonfalon/strings/isValidKey';

export type CustomPropertyFormProps = {
  name: string;
  key: string;
  value: Set<string>;
  new: boolean;
  type?: string;
};

export class CustomPropertyForm extends Record<CustomPropertyFormProps>({
  name: '',
  key: '',
  value: Set(),
  new: false,
  type: undefined,
}) {
  validate() {
    const isValidSize = isLength(0, 64);
    const isValidLength = isLength(0, 65536);
    const predicates = [
      isNotEmpty('name'),
      isNotEmpty('key'),
      isValidSize('name'),
      isValidSize('key'),
      isValidSize('value'),
      isValidKey('key'),
      isReservedKey('key'),
      // isValidEach((v) => validateRecord(fromJS({ v }), isValidLength('v')).toJS(), 'value'),
      isValidEach(
        (v: string) => validateRecord(fromJS({ v }), isValidLength('v')).toJS() as ValidationResults,
        'value',
      ),
    ];

    return validateRecord(this, ...predicates);
  }
}

export function createCustomPropertyForm(props: CreateFunctionInput<CustomPropertyForm> = {}) {
  return props instanceof CustomPropertyForm ? props : new CustomPropertyForm(fromJS(props));
}
